var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useForm } from "react-hook-form";
import { RegisterApi } from '../register.api';
import { loginMember } from "../../../store/login.store";
import { customStyles } from "../../../definitions/constants/modal.constant";
import { callLoginApi } from "../../../services/login.services";
import { dataLayerPushEvent } from "../../../services/push.services";
import { modalServiceSubject } from "../../../components/modal/modal";
import Clock from "../../../assets/feather/clock.svg";
function ValidationSmsModal(props) {
    var _a = useState(""), errorMessage = _a[0], setErrorMessage = _a[1];
    var _b = useState(false), isActiveLoading = _b[0], setIsActiveLoading = _b[1];
    function closeModal() {
        props.setIsOpen(false);
    }
    var _c = useForm(), register = _c.register, handleSubmit = _c.handleSubmit, errors = _c.formState.errors;
    var onSubmit = function (data) {
        codeMobileApi(data);
    };
    var codeMobileApi = function (data) {
        setIsActiveLoading(true);
        var registerData = props.smsValidateData;
        registerData.mobile_confirm_token = props.mobileConfirmToken;
        registerData.code = data.code;
        RegisterApi.register(registerData).then(function (result) {
            setIsActiveLoading(false);
            if (result.status) {
                props.setIsOpen(false);
                callLoginApi(loginMember.tc_id, loginMember.password);
                dataLayerPushEvent('sign_up', result.data);
            }
            else {
                if (result.data && result.data.hasOwnProperty('re-register')) {
                    modalServiceSubject.next({
                        title: "Uyarı!",
                        content: 'Lütfen tekrar deneyiniz.',
                        confirm: {
                            cancel: { label: 'Tamam' }
                        },
                        timeout: 0
                    });
                    props.setIsOpen(false);
                }
                else {
                    setErrorMessage(result.message);
                }
            }
        });
    };
    if (!props.modalIsOpen) {
        return _jsx(_Fragment, {}, void 0);
    }
    return (_jsx(_Fragment, { children: _jsx(Modal, __assign({ isOpen: props.modalIsOpen, onRequestClose: closeModal, shouldCloseOnOverlayClick: false, shouldCloseOnEsc: false, shouldReturnFocusAfterClose: false, style: customStyles, contentLabel: "" }, { children: _jsxs("div", __assign({ className: "card" }, { children: [_jsx("h3", { children: "Telefon Do\u011Frulama" }, void 0), !isActiveLoading && _jsxs("label", { children: ["L\u00FCtfen ", loginMember.mobile, " numaras\u0131na g\u00F6nderilen kodu girip telefon numaran\u0131z\u0131 onaylay\u0131n\u0131z.", props.modalIsOpen ? _jsx(_Fragment, { children: _jsx("div", { children: _jsx(CountDown, { timer: 180, mobileConfirmToken: props.mobileConfirmToken }, void 0) }, void 0) }, void 0) : _jsx(_Fragment, {}, void 0)] }, void 0), isActiveLoading && _jsx("p", { children: "Telefon numaran\u0131z ve \u00FCyelik bilgileriniz do\u011Frulan\u0131yor l\u00FCtfen bekleyiniz..." }, void 0), _jsxs("div", __assign({ className: "card-body p-0" }, { children: [!isActiveLoading && _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [_jsxs("div", { children: [_jsx("input", __assign({ placeholder: "Doğrulama Kodu" }, register('code', {
                                                required: true,
                                                maxLength: 6,
                                                minLength: 6
                                            }), { type: "number", className: "form-control" }), void 0), errors.code && errors.code.type === "required" &&
                                                _jsx("span", __assign({ className: "text-validation" }, { children: "L\u00FCtfen do\u011Frulama kodu giriniz." }), void 0)] }, void 0), errorMessage && errorMessage != '' &&
                                        _jsx("p", __assign({ className: "py-1 mt-1 alert alert-danger text-center" }, { children: errorMessage }), void 0), _jsx("input", { className: "btn btn-primary btn-large mt-3", type: "submit", value: "DO\u011ERULA" }, void 0)] }), void 0), isActiveLoading && _jsx("div", __assign({ className: "d-flex justify-content-center mb-2 mt2" }, { children: _jsx("img", { className: "loadingRotationImage", src: Clock, width: "50" }, void 0) }), void 0)] }), void 0)] }), void 0) }), void 0) }, void 0));
}
export default ValidationSmsModal;
function secondsToTime(secs) {
    var hours = Math.floor(secs / (60 * 60));
    var divisor_for_minutes = secs % (60 * 60);
    var minutes = Math.floor(divisor_for_minutes / 60);
    var divisor_for_seconds = divisor_for_minutes % 60;
    var seconds = Math.ceil(divisor_for_seconds);
    var obj = {
        "h": String(hours).padStart(2, '0'),
        "m": String(minutes).padStart(2, '0'),
        "s": String(seconds).padStart(2, '0')
    };
    return obj;
}
var timerRegisterCountDown;
export function CountDown(props) {
    var timer = props.timer;
    var _a = useState(timer), timeLeft = _a[0], setTimeLeft = _a[1];
    useEffect(function () {
        if (timeLeft > 0) {
            timerRegisterCountDown = setTimeout(function () {
                setTimeLeft(timeLeft - 1);
            }, 1000);
        }
        return function () {
            clearTimeout(timerRegisterCountDown);
        };
    }, [timeLeft]);
    if (timeLeft <= 0) {
        return (_jsxs(_Fragment, { children: ["S\u00FCre doldu! tekrar do\u011Frulama kodu g\u00F6ndermeniz gerekiyor. ", _jsx("a", __assign({ onClick: function () {
                        var data = loginMember;
                        data['mobile_confirm_token'] = props.mobileConfirmToken;
                        RegisterApi.register(data).then(function () {
                            setTimeLeft(timer);
                        });
                    }, style: { cursor: 'pointer', fontWeight: 'bold', color: 'var(--color-danger)' } }, { children: "Tekrar G\u00F6nder" }), void 0), " "] }, void 0));
    }
    return (_jsx(_Fragment, { children: _jsxs("span", { children: [_jsxs("b", { children: [secondsToTime(timeLeft).m, ":", secondsToTime(timeLeft).s] }, void 0), " saniye sonra yeniden kod g\u00F6nderebilirsiniz."] }, void 0) }, void 0));
}
